import { capitalCase } from "change-case";
import { isNumber } from "lodash";
import React, { useCallback, useContext, useEffect } from "react";

import styled from "styled-components";
import { PrimaryButton } from "../../../../components/button";
import { GlobalOverlayContext } from "../../../../components/overlay/context";
import { formatEther } from "../../../../utils/utils";
import { StakeContext } from "../context";
import UnstakeModal from "../form/unstake-modal";
import { useTimeLeftToClaim } from "./common";
import Tile from "./tile";

interface IUnstakeTileProps { }

const StyledTile = styled(Tile)`
  border: none;
  background: none;
  box-shadow: none;
`;

const UnstakeTile: React.FunctionComponent<IUnstakeTileProps> = (props) => {
  const { currentContract } = useContext(StakeContext);
  const { setOverlay } = useContext(GlobalOverlayContext);
  const timeLeft = useTimeLeftToClaim();

  const openUnstakingModal = useCallback(() => {
    setOverlay({
      children: <UnstakeModal onClose={() => setOverlay({ children: null })} />,
      title: "Unlock $SKRT",
      onClose: () => Promise.resolve(),
    });
  }, [setOverlay, UnstakeModal]);

  const [isMounted, setIsMounted] = React.useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isMounted || !currentContract.map((x) => x.walletInfo).isDefined()) {
    return (
      <StyledTile
        title="Your Locked $SKRT"
        comingSoon={<span></span>}
        cta={<PrimaryButton fullWidth>&nbsp;</PrimaryButton>}
      >
        &nbsp;
      </StyledTile>
    );
  }

  return currentContract
    .map((x) => x.walletInfo)
    .fold(
      () => null,
      ({ balance }) => (
        <StyledTile
          title="Your Locked $SKRT"
          cta={
            <PrimaryButton
              fullWidth
              onClick={openUnstakingModal}
              disabled={
                timeLeft.isDefined() ||
                balance.isZero() ||
                currentContract.map(({ active }) => !active).getOrElse(true)
              }
            >
              {timeLeft.fold(
                () => (
                  <strong>UNLOCK</strong>
                ),
                (remaining) =>
                  `${isNumber(remaining)
                    ? `${remaining} Days`
                    : capitalCase(remaining)
                  } Left to Unlock`
              )}
            </PrimaryButton>
          }
        >
          $SKRT&nbsp;
          {formatEther(balance)}
        </StyledTile>
      )
    );
};

export default UnstakeTile;
